import { get, mergeWith } from "lodash/object";

export const HttpRequestException = (errorType, error, event, options = {}) => ({errorType, serverResponse: get(error, 'response', error), event: event || errorType, options});

export function overwriteArrays(currentConfig, newConfig) {
  if (Array.isArray(newConfig)) {
    return newConfig;
  }
}

const getRoundedStatusCode = code => code && (Math.floor(code / 100) * 100);

export const getErrorConfigByHttpResponseStatus = (errorType, httpStatusCode, errorsConfig) => {
  const roundedStatusCode = getRoundedStatusCode(httpStatusCode);
  const matchByTypeAndExactStatus = get(errorsConfig, `byHttpRequestTypeAndResponseStatus.${errorType}.${httpStatusCode}`, {});
  const matchByTypeAndRoundedStatus = get(errorsConfig, `byHttpRequestTypeAndResponseStatus.${errorType}.${roundedStatusCode}`, {});
  const matchByTypeAndDefaultStatus = get(errorsConfig, `byHttpRequestTypeAndResponseStatus.${errorType}.default`, {});
  const matchDefaultTypeAndExactStatus = get(errorsConfig, `byHttpRequestTypeAndResponseStatus.default.${httpStatusCode}`, {});
  const matchDefaultTypeAndRoundedStatus = get(errorsConfig, `byHttpRequestTypeAndResponseStatus.default.${roundedStatusCode}`, {});
  const matchDefaultTypeAndDefaultStatus = get(errorsConfig, `byHttpRequestTypeAndResponseStatus.default.default`, {});

  return mergeWith({}, matchDefaultTypeAndDefaultStatus, matchDefaultTypeAndRoundedStatus, matchDefaultTypeAndExactStatus, matchByTypeAndDefaultStatus, matchByTypeAndRoundedStatus, matchByTypeAndExactStatus, overwriteArrays);
};

export const getPropsByHttpResponseStatus = (httpStatusCode, propsByHttpStatus = {}) => {
  const exactMatch = get(propsByHttpStatus, httpStatusCode, {});
  const roughMatch = get(propsByHttpStatus, `${(Math.floor(httpStatusCode / 100) * 100)}`, {});
  const defaultMatch = get(propsByHttpStatus, 'default', {});
  return mergeWith({}, defaultMatch, roughMatch, exactMatch, overwriteArrays);
};

export const transformStatusErrorMessage = (message, errorMessages = {}) => {
  let errorDescription;
  Object.keys(errorMessages).forEach(errorMessage => {
    if (message.indexOf(errorMessage) !== -1) {
      errorDescription = errorMessages[errorMessage];
    }
  });

  return errorDescription;
};
